import { h, clear } from '../utils/dom.js';

const THEME_ICON = { light: '☀️', dark: '🌙', sepia: '📜' };
const FONT_SIZES = ['small', 'medium', 'large', 'x-large'];

export function renderToolbar(container, state, actions) {
	clear(container);

	const refLabel = state.chapterData
		? `${state.chapterData.bookName} ${state.chapterData.chapter}`
		: `${state.book} ${state.chapter}`;

	const items = [
		h(
			'button',
			{
				class: 'blb-toolbar-btn blb-toolbar-ref',
				onClick: () => actions.openDrawer('navigator'),
				title: 'Browse books & chapters',
			},
			['📚 ', h('span', { class: 'blb-btn-label' }, refLabel)]
		),
		h(
			'button',
			{ class: 'blb-toolbar-btn', onClick: () => actions.randomChapter(), title: 'Jump to a random chapter' },
			['🎲 ', h('span', { class: 'blb-btn-label' }, 'Random')]
		),
		h(
			'button',
			{ class: 'blb-toolbar-btn', onClick: () => actions.randomKeyVerse(), title: 'Jump to a random key verse' },
			['✨ ', h('span', { class: 'blb-btn-label' }, 'Key Verse')]
		),
	];

	if (state.features.search) {
		items.push(
			h(
				'button',
				{ class: 'blb-toolbar-btn', onClick: () => actions.openSearch(), title: state.i18n.search },
				['🔍 ', h('span', { class: 'blb-btn-label' }, 'Search')]
			)
		);
	}

	if (state.features.plans) {
		items.push(
			h(
				'button',
				{
					class: 'blb-toolbar-btn' + (state.drawer === 'plan' ? ' blb-active' : ''),
					onClick: () => actions.openDrawer('plan'),
					title: 'Reading plans',
				},
				['📅 ', h('span', { class: 'blb-btn-label' }, 'Plans')]
			)
		);
	}

	if (state.features.readAloud && actions.ttsSupported()) {
		if (state.speaking.active) {
			items.push(
				h(
					'button',
					{
						class: 'blb-toolbar-btn blb-active',
						onClick: () => actions.togglePauseReadAloud(),
						title: state.speaking.paused ? 'Resume reading aloud' : 'Pause reading aloud',
					},
					state.speaking.paused ? '▶️' : '⏸️'
				)
			);
			items.push(
				h('button', { class: 'blb-toolbar-btn', onClick: () => actions.stopReadAloud(), title: 'Stop reading aloud' }, '⏹️')
			);
		} else {
			items.push(
				h(
					'button',
					{ class: 'blb-toolbar-btn', onClick: () => actions.startReadAloud(), title: 'Read this chapter aloud' },
					'🔊'
				)
			);
		}
	}

	if (state.features.compare && state.translations && state.translations.length > 1) {
		items.push(
			h(
				'button',
				{
					class: 'blb-toolbar-btn' + (state.compare.mode ? ' blb-active' : ''),
					onClick: () => actions.openDrawer('compare'),
					title: state.i18n.compareTitle || 'Compare translations',
				},
				['⇄ ', h('span', { class: 'blb-btn-label' }, state.i18n.compare || 'Compare')]
			)
		);
	}

	items.push(h('span', { class: 'blb-toolbar-spacer' }));

	if (state.translations && state.translations.length > 1) {
		const current = state.translations.find((t) => t.id === state.translation);

		const wrap = h('div', { class: 'blb-translation-wrap' }, [
			h(
				'button',
				{
					class: 'blb-toolbar-btn blb-translation-toggle',
					title: 'Translation',
					onClick: (e) => {
						e.stopPropagation();
						actions.toggleTranslationMenu();
					},
				},
				[current ? current.abbrev : state.translation, ' ▾']
			),
		]);

		if (state.translationMenuOpen) {
			const menu = h('div', { class: 'blb-translation-menu' }, [
				h('div', { class: 'blb-translation-menu-title' }, 'Translation'),
				...state.translations.map((t) =>
					h(
						'button',
						{
							class: 'blb-translation-menu-item' + (t.id === state.translation ? ' blb-active' : ''),
							onClick: (e) => {
								e.stopPropagation();
								actions.setTranslation(t.id);
								actions.closeTranslationMenu();
							},
						},
						[h('strong', null, t.abbrev), ' — ', h('span', { class: 'blb-translation-menu-name' }, t.name)]
					)
				),
			]);
			wrap.appendChild(menu);
		}

		items.push(wrap);
	}

	const fontGroup = h('div', { class: 'blb-toolbar-group', title: 'Font size' }, [
		h('button', { class: 'blb-toolbar-btn', onClick: () => actions.adjustFontSize(-1) }, 'A−'),
		h('button', { class: 'blb-toolbar-btn', onClick: () => actions.adjustFontSize(1) }, 'A+'),
	]);
	items.push(fontGroup);

	items.push(
		h(
			'button',
			{ class: 'blb-toolbar-btn', onClick: () => actions.cycleLineHeight(), title: 'Line height' },
			'☰'
		)
	);

	items.push(
		h(
			'button',
			{ class: 'blb-toolbar-btn', onClick: () => actions.cycleTheme(), title: 'Theme: ' + state.theme },
			THEME_ICON[state.theme] || '☀️'
		)
	);

	if (state.features.bookmarks || state.features.highlights || state.features.notes) {
		items.push(
			h(
				'button',
				{ class: 'blb-toolbar-btn', onClick: () => actions.openDrawer('saved'), title: state.i18n.bookmarks },
				'⭐'
			)
		);
	}

	items.forEach((item) => container.appendChild(item));
}

export { FONT_SIZES };
